export const getDateTimestamp = (d: string | null | undefined): number => {
  if (!d) return 0;
  const timestamp = new Date(d).getTime();
  return isNaN(timestamp) ? 0 : timestamp;
};

export function formatTimeAgo(dateString: string | null | undefined): string {
  if (!dateString) return '';
  const diff = Date.now() - new Date(dateString).getTime();
  const totalSeconds = Math.floor(diff / 1000);
  if (totalSeconds < 60) return 'just now';
  const totalMinutes = Math.floor(totalSeconds / 60);
  if (totalMinutes < 60) return totalMinutes + 'm ago';
  const totalHours = Math.floor(totalMinutes / 60);
  if (totalHours < 24) return totalHours + 'h ago';
  const totalDays = Math.floor(totalHours / 24);
  if (totalDays < 30) return totalDays + 'd ago';
  return new Date(dateString).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
